import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import servicio from "@/services/servicio-catalogo-general"
import servicioDetalle from "@/services/servicio-detalle-producto"
import servicioReferenciarPagos from "@/services/servicio-referencia-pagos"
//import Swal from "sweetalert2"

export default new Vuex.Store({
  state: {
    loading: false,
    msgLoading: 'Espere un momento ...',

    busqueda: {
      parametros: {
        buscar: "",
        orden: 0,
        codClasificacion: 0,
        codFormaFarmaceutica: 0,
        tipoFormula: "A",
        codFormula: 0,
        contenidoVenta: 0,
        pagina: 1,
        busquedaAvanzada: false
      },
      resultados: {
        resultados: [],
        resultadosPrincipales: [],
        resultadosSugeridos: [],
        formasFarmaceuticas: [],
        clasificaciones: [],
        pagina: 1,
        totalPaginas: 1,
        genericosDisponibles: [],
      },
      itemSeleccionadoBuscador: false,
      itemsSustitutos: []
    },
    permitirReferenciar: false

  },
  getters: {
  },
  mutations: {
    setLoading(state, isLoading) {
      state.loading = isLoading
    },
    setMsgLoading(state, msg) {
      state.msgLoading = msg
    },
    setResultados(state, resultados) {
      state.busqueda.resultados = resultados
    },
    setParametros(state, parametros) {
      //console.log("entro al store => ", parametros)      
      state.busqueda.parametros = parametros
    },
    setItemSeleccionadoBuscador(state, itemSeleccionadoBuscador) {
      state.busqueda.itemSeleccionadoBuscador = itemSeleccionadoBuscador
    },
  },
  actions: {
    async buscarProductos(context) {
      context.state.loading = true
      context.state.busqueda.resultados = {
        resultados: [],
        resultadosPrincipales: [],
        resultadosSugeridos: [],
        formasFarmaceuticas: [],
        clasificaciones: [],
        pagina: 1,
        totalPaginas: 1,
        genericosDisponibles: []
      }

      let r = await servicio.buscar(context.state.busqueda.parametros)

      context.state.loading = false

      if (r.data != undefined) {
        context.state.busqueda.resultados = r.data
      }

      // if(r.data == undefined){
      //   Swal.fire({
      //     text: 'No se encontraron resultados para mostrar',
      //     icon: "warning"
      //   })
      // }
      // else{
      //   context.state.busqueda.resultados = r.data
      // }

    },
    obeterAccesoReferenciar(context) {
      servicioReferenciarPagos.obeterAccesoReferenciar()
        .then((r) => {
          context.state.loading = true
          if (r.value) {
            context.state.permitirReferenciar = true;
          }

        })
        .catch((error) => {
          context.state.loading = false
          console.log(error)
        })
    },
    async sustitutos(context) {
      //this.mostrarModalSustitutos = false
      var articulo = context.state.busqueda.parametros.buscar
      let r = await servicioDetalle.productosSustitutos(articulo)
      console.log("data de sustitutos", r.data)
      if (r.data != undefined) {
        context.state.busqueda.itemsSustitutos = r.data
      }
    },

    resetParametros(context) {
      context.state.busqueda.parametros = {
        buscar: "",
        orden: 0,
        codClasificacion: 0,
        codFormaFarmaceutica: 0,
        tipoFormula: "A",
        codFormula: 0,
        contenidoVenta: 0,
        pagina: 1,
        busquedaAvanzada: false
      }

      return context.state.busqueda.parametros
    },
    resetResultados(context) {
      context.state.busqueda.resultados = {
        resultados: [],
        resultadosPrincipales: [],
        resultadosSugeridos: [],
        formasFarmaceuticas: [],
        clasificaciones: [],
        pagina: 1,
        totalPaginas: 1,
        genericosDisponibles: []
      }

      return context.state.busqueda.resultados
    },
    resetItemSustitutos(context) {
      context.state.busqueda.itemsSustitutos = []

      return context.state.busqueda.itemsSustitutos
    }
  },
  modules: {

  }
})
